import styled from 'styled-components';
import { Modal, Button, Group } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;

export const ModalContent = styled.div``;

export const ModalTitle = styled.div`
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  font-weight: ${typography.weight4};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size4};
    line-height: ${typography.lineHeight4};
    font-weight: ${typography.weight4};
  }
`;

export const FirstParagraph = styled.p`
  margin: 0 0 20px 0;
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const SecondParagraph = styled.p`
  margin: 0;
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};
  text-align: left;

  @media (max-width: 768px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;

export const StyledGroup = styled(Group)`
  margin-top: 25px;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 10px;
  }
`;

export const CancelButton = styled(Button)`
  width: 112px;
  height: 48px;
  padding: 14px ${layout.size5}px;
  border-radius: ${layout.cornerRadius2}px;
  border: 1px solid ${color.electricBlue7};
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight2};

  @media (max-width: 768px) {
    width: 112px;
    height: 36px;
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight2};
  }
`;

export const ProceedButton = styled(Button)`
  width: 158px;
  height: 48px;
  padding: 14px ${layout.size5}px;
  border-radius: ${layout.cornerRadius2}px;
  background-color: ${color.electricBlue7};
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight2};

  @media (max-width: 768px) {
    width: 158px;
    height: 36px;
  }
`;

export const StyledModal = styled(Modal)`
  padding: 40px 48px !important;
  .veneer-modal__dialog {
    border-radius: ${layout.cornerRadius2}px !important;
  }

  .veneer-modal__content {
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  @media (max-width: 768px) {
    padding: ${layout.size5}px !important;
  }
`;
